<template>
    <MainSlot>
        <div class="page_bg">
            <div v-show="is_loaded_page" class="row w100">
                <div class="col l10 s12">
                    <h3>{{ $t("EditProfile['Edit profile']") }}</h3>
                </div>

                <div class="container col l10 s12">
                    <div class="block">
                        <h5>{{ $t("EditProfile['User Info:']") }}</h5>
                        <div class="input">
                            <div class="input-field">
                                <input id="first_name" type="text" v-model="user.first_name">
                                <label for="first_name">{{ $t("EditProfile['First Name']") }}</label>
                            </div>
                        </div>

                        <div class="input">
                            <div class="input-field">
                                <input id="last_name" type="text" v-model="user.last_name">
                                <label for="last_name">{{ $t("EditProfile['Last Name(optional)']") }}</label>
                            </div>
                        </div>

                        <div class="input">
                            <label for="first_name">{{ $t("EditProfile['Date of birth']") }}</label>
                            <div class="input-field">
                                <input
                                    id="birth_date"
                                    type="text"
                                    v-model="user.birth_date"
                                    ref="datepicker"
                                    class="datepicker"
                                    @change="changedPicker"
                                >
                            </div>
                        </div>
                    </div>

                    <!-- location -->
                    <div class="block">
                        <h5>{{ $t("EditProfile['Your location:']") }}</h5>
                        <div class="input">
                            <div class="input-field location mb29">
                                <input id="location"
                                       v-model="location"
                                       ref="location"
                                       :name="randomInputName()"
                                       @blur="checkCorrectLocation"
                                       @focus="clearIncorrectAutocomplete"
                                       :placeholder="$t(`EditProfile['Start typing to add']`)"
                                       type="text">
                                <!--                            <div v-show="autocomplete.incorrect" class="error-message">Incorrect Value</div>-->
                            </div>
                        </div>
                    </div>

                    <!-- language -->
                    <div class="block">
                        <h5>Your languages:</h5>
                        <div class="input">
                            <div v-show="user.languages && user.languages.length" class="tags_wrapper input-field">
                                <div v-for="lang of user.languages"
                                     class="app_tag">
                                    <div class="title">{{ lang.title }}</div>
                                    <svg @click="deleteUserTag('languages',lang.title)"
                                         width="12" height="12" viewBox="0 0 12 12" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"/>
                                        <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="input-field mb29">
                            <input id="language"
                                   ref="language"
                                   :placeholder="$t(`EditProfile['Start typing to add']`)"
                                   type="text">
                        </div>
                    </div>

                    <!-- Field of work -->
                    <div class="block">
                        <h5>Field of work:</h5>
                        <div class="input">
                            <div class="input-field mb29 w100">
                                <div class="pseudo_input dropdown-trigger"
                                     ref="profession_dropdown"
                                     id="profession_field"
                                     data-target="profession_dropdown">
                                    <span
                                        v-if="!user.profession">{{
                                            $t("EditProfile['Choose one from the list']")
                                        }}</span>
                                    <template v-else>
                                        <span class="selected">{{ user.profession.title }}</span>
                                    </template>
                                    <div class="arrow_down"></div>
                                </div>

                                <ul id='profession_dropdown'
                                    class='dropdown-content'>
                                    <!-- zero select -->
                                    <li
                                        @touchend.stop="setUserProfession(null, $event)"
                                        @click.stop="setUserProfession(null, $event)"
                                        class="select_zero"
                                    >
                                        <span>{{ $t("EditProfile['Choose one from the list']") }}</span>
                                    </li>
                                    <!-- prof select -->
                                    <li
                                        v-for="profession of autocompletes.professions.data"
                                        v-if="autocompletes.professions.data.length"
                                        :class="{checked:user.profession === profession.title}"
                                        @touchend.stop="setUserProfession(profession, $event)"
                                        @click.stop="setUserProfession(profession, $event)"
                                    >
                                        <span>{{ profession.title }}</span>

                                        <img
                                            v-if="user.profession === profession.title"
                                            src="../assets/img/check.svg"
                                            alt="check icon"
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="block">
                        <h5>{{ $t(`EditProfile['Your interests:']`) }}</h5>
                        <div class="input">
                            <div v-show="user.interests" class="tags_wrapper input-field">
                                <div
                                    v-for="interest of user.interests"
                                    class="app_tag">
                                    <img src="../assets/img/tag-label-icon.svg"
                                         class="left"
                                         alt="tag-label-icon">
                                    <div class="title">{{ interest.title }}</div>
                                    <svg
                                        @click="deleteUserTag('interests', interest.title)"
                                        width="12" height="12" viewBox="0 0 12 12" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"/>
                                        <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="input-field mb29">
                            <input id="interests"
                                   ref="interests"
                                   :placeholder="$t(`EditProfile['Start typing to add']`)"
                                   type="text">
                        </div>
                    </div>

                    <div class="block">
                        <h5>{{ $t(`SocialAuthStepThree['Bio(optional)']`) }}</h5>
                        <textarea v-show="show_bio"
                                  id="biography"
                                  ref="biography"
                                  v-model="user.biography"
                                  @change="resizeTextarea"
                                  @input="resizeTextarea"
                                  class="materialize-textarea"
                                  :placeholder="$t(`EditProfile['A few words about yourself(optional)']`)"
                                  type="text">
                    </textarea>
                    </div>

                    <div class="buttons_wrapper_between two">
                        <div class="btn white mr30"
                             @click="goBack"
                        >
                            {{ $t(`buttons['CANCEL']`) }}
                        </div>
                        <div class="btn"
                             @click="updProfile"
                        >
                            {{ $t(`buttons['SAVE CHANGES']`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </MainSlot>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {errorMessage} from "../services/messges";
import moment from "moment-timezone";
import {clearGoogleScripts} from "../utils/tools";

export default {
    name: "EditProfile",
    data() {
        return {
            user: {},
            pickers: {
                date: null
            },
            initMapOnMount: false,
            location: '',
            selected_social: null,
            social_value: {
                WhatsApp: null,
                Snapchat: null,
                value: null,
            },
            dropdowns: {
                social: null,
                profession: null
            },
            autocompletes: {
                language: {
                    data: [],
                    instance: null,
                },
                professions: {
                    data: {},
                    instance: null,
                },
                interests: {
                    data: [],
                    instance: null,
                },
            },
            autocomplete: {
                location: null,
                variants: {},
                last_location: '',
                incorrect: false
            },
            show_bio: false,
            service: null,
        };
    },
    computed: {
        ...mapGetters([
            'isLogged',
            'isLoginChecked',
            'getUserInfo',
            'getLanguages',
            'getProfessions',
            'getInterests',
            'is_loaded_page',
        ]),
        interestsObject() {
            const obj = {};
            for (let lang of this.autocompletes.interests.data) {
                obj[lang.title] = null;
            }
            return obj;
        },
        languagesObject() {
            const obj = {};
            for (let lang of this.autocompletes.language.data) {
                obj[lang.title] = null;
            }
            return obj;
        },
    },
    methods: {
        ...mapMutations([
            "setLogged",
            'setLoading',
            'set_is_loaded_page'
        ]),
        ...mapActions([
            'loadUserInfo',
            'loadAutocompleteData',
        ]),
        resizeTextarea(ev) {
            M.textareaAutoResize(ev.target);
        },
        sizeTextarea(el) {
            if (!el) return;
            M.textareaAutoResize(el);
        },
        setUserProfession(value, event) {
            event.stopPropagation();
            if (!value) {
                value = {
                    id: 0,
                    title: this.$t("EditProfile['Choose one from the list']")
                }
            }
            this.user.profession = value;
        },
        setUserSocial(value, event) {
            event.stopPropagation();
            this.selected_social = value;
        },
        clearUserSocial(value, event) {
            event.stopPropagation();
            this.selected_social = null;
            this.social_value.WhatsApp = null;
            this.social_value.Snapchat = null;
        },
        addInterest(title) {
            if (!this.inArrayByTitle('interests', title)) {
                this.user.interests.push(this.autocompletes.interests.data.find(el => el.title === title))
            }
        },
        inArrayByTitle(array_prop, title) {
            return this.user[array_prop].some(el => el.title === title);
        },
        social_get_values() {
            let social = this.user.social;
            social.forEach((item) => {
                if (item.title === "WhatsApp") {
                    this.social_value.WhatsApp = item.value;
                    this.selected_social = 'WhatsApp';
                }
                if (item.title === "Snapchat") {
                    this.social_value.Snapchat = item.value;
                    this.selected_social = 'Snapchat';
                }
            });
        },
        // only one option of social contact is possible
        social_set_values(obj) {
            this.social_value.Snapchat = null;
            this.social_value.WhatsApp = null;
            this.social_value[obj['params']] = obj['value'];
        },
        deleteUserTag(prop, title) {
            this.user[prop] = this.user[prop].filter(el => el.title !== title);
        },
        async afterLoginChecked() {
            await this.loadUserInfo();
            this.set_is_loaded_page(true);
            this.user = this.getUserInfo;
            this.$nextTick(_ => {
                M?.updateTextFields();
            })
            this.social_get_values();
            this.sizeTextarea(this.$refs.biography);
            this.show_bio = true;
            this.location = this.user?.location?.title || null;
        },
        changedPicker(ev) {
            this.user.birth_date = ev.target.value;
        },
        reInitPickers() {
            if (this.pickers.date) {
                this.pickers.date?.destroy();
                this.pickers.date = null;
            }
            this.pickers.date = M.Datepicker.init(this.$refs.datepicker, {
                format: 'dd.mm.yyyy',
                maxDate: moment().toDate(),
                yearRange: 120,
                minYear: '1900',
                maxYear: moment().format('yyyy'),
                onDraw: () => {
                },
                onOpen: () => {
                },
                onClose: (val) => {
                }
            });
        },
        addLang(title) {
            if (!this.isUserHasLang(title)) {
                this.user.languages.push(this.autocompletes.language.data.find(el => el.title === title));
            }
        },
        isUserHasLang(title) {
            return this.inArrayByTitle('languages', title);
        },
        checkCorrectLocation() {
            let timeout = setTimeout(_ => {
                if (this.user.location && this.autocomplete.last_location !== this.user.location) {
                    this.autocomplete.incorrect = true;
                }
                clearTimeout(timeout);
            }, 500);
        },
        clearIncorrectAutocomplete() {
            this.autocomplete.incorrect = false;
        },
        randomInputName() {
            return Math.random().toString(36).substring(2, 10);
        },
        reInitAutocomplete(object = null) {
            if (this.autocomplete.location) {
                this.autocomplete.location.updateData(object || this.autocomplete.variants)
            } else {
                this.autocomplete.location = M.Autocomplete.init(this.$refs.location, {
                    data: object || this.autocomplete.variants,
                    onAutocomplete: (title) => {
                        this.user.location = title;
                        this.autocomplete.last_location = title;
                    }
                });
            }

            this.autocompletes.language.data = this.getLanguages;
            this.autocompletes.language.instance = M.Autocomplete.init(this.$refs.language, {
                data: this.languagesObject,
                onAutocomplete: (title) => {
                    this.addLang(title);
                    this.$refs.language.value = null;
                    this.$refs.language.focus();
                }
            });

            this.autocompletes.professions.data = this.getProfessions;
            this.dropdowns.social = M.Dropdown.init(this.$refs.social_dropdown);

            this.dropdowns.profession = M.Dropdown.init(this.$refs.profession_dropdown);
            this.autocompletes.interests.data = this.getInterests;
            this.autocompletes.interests.instance = M.Autocomplete.init(this.$refs.interests, {
                data: this.interestsObject,
                onAutocomplete: (title) => {
                    this.addInterest(title);
                    this.$refs.interests.value = null;
                    this.$refs.interests.focus();
                }
            });

        },
        MapsInit() {
            this.service = new window.google.maps.places.AutocompleteService();
        },
        displaySuggestions(predictions, status) {
            if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
                this.searchResults = []
                return;
            }
            this.searchResults = predictions.map(prediction => {
                if (prediction.terms && prediction.terms.length === 3) {
                    return `${prediction.terms[0].value}, ${prediction.terms[2].value}`;
                }
                return prediction.description;
            })
            const variants = {};
            for (const title of this.searchResults) {
                variants[title] = null;
            }
            this.autocomplete.variants = variants;
            this.reInitAutocomplete(variants);
        },
        goBack() {
            window.history.back();
        },
        async updProfile() {

            const {
                first_name,
                last_name,
                birth_date,
                languages,
                interests,
                profession,
                biography,
                location
            } = this.user;

            if (!first_name) {
                errorMessage(this.$t("validation['The First Name field cannot be empty']"));
                return false;
            }
            let data = {
                first_name: first_name,
                last_name: last_name,
                birth_date: birth_date,
                languages: languages,
                interests: interests,
                profession: profession,
                biography: biography,
                location: (this.location == '') ? [] : location,
                social: this.social_value,
            }

            try {
                this.setLoading(true);
                await this.$http.postAuth(`${this.$http.apiUrl()}users/user/upd_profile`, data);
                window.history.back();
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t("validation['Something went wrong...']"));
            }

            this.setLoading(false);
        },
    },
    watch: {
        async isLoginChecked(val) {
            if (val) {
                await this.afterLoginChecked();
            }
        },
        'location': function (newValue) {
            if (newValue &&
                this.location &&
                this.service &&
                this.location.length > 1 &&
                (this.location !== this.autocomplete.last_location)
            ) {
                this.service.getPlacePredictions({
                    input: this.location,
                    types: ['(cities)']
                }, this.displaySuggestions)
            }
        },
        getLanguages(val) {
            this.reInitAutocomplete();
        },
        getProfessions(val) {
            this.reInitAutocomplete();
        },
    },
    async mounted() {
        this.set_is_loaded_page(false);
        await this.$emit('check-login');
        if (this.initMapOnMount) {
            this.MapsInit();
        }
        this.reInitPickers();
        await this.loadAutocompleteData();
        if (this.isLoginChecked) {
            await this.afterLoginChecked();
        }
    },
    updated() {
        this.sizeTextarea(document.getElementById('biography'));
    },
    metaInfo() {
        const obj = {
            title: 'Edit Profile Page',
            titleTemplate: '%s | Speed Friending Webapp'
        }
        if (!window?.google?.maps) {
            obj.script = [{
                vmid: 'google-maps-autocomplete',
                src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCPv_T-pHqaTKYP91yOjX6ARZpH52h8paM&libraries=places&language=en`,
                async: true,
                defer: true,
                callback: () => this.MapsInit()
            }]
        } else {
            this.initMapOnMount = true;
        }
        return obj;
    },
    beforeDestroy() {
        clearGoogleScripts();
    }
}
</script>

<style lang="scss" scoped>

h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 28px;
    display: flex;
    align-items: center;
    color: #272727;
}

.col {
    margin: 0px auto;
    float: none;
}

.row {
    margin-bottom: 0px;
}

.logged {
    height: auto !important;
}

.container {
    max-width: 540px;
    margin: 0 auto;
    width: 100%;

    .block {

        max-width: 100%;
        width: 100%;

        h5 {
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 23px;
            align-items: center;
            color: #272727;
            margin-bottom: 0;

            &.social-account {
                margin-top: 25px;
            }
        }

        #profession_field {
            height: 3em;

            span {
                display: block;
                margin-top: 0.7em;
            }
        }

        #social_field {
            height: 3em;
            width: 100%;
            display: flex;
            align-items: center;

            span {
                margin-top: 10px;
                display: block;
            }
        }

        .input {
            margin-top: 20px;

            label {
                font-style: normal;
                font-weight: 600;
                font-size: 13px;
                line-height: 16px;
                color: #B8B5C8;
            }

            .input-field {
                margin-top: 0.5rem;
                margin-bottom: 0;
            }
        }

        textarea {
            background: #FBFCFF;

            &::placeholder {
                color: #a8a8a8;
            }
        }
    }

    .input-field.social {

        display: flex;

        .input-field.no_margin {
            margin-top: 0;
            padding-right: 0;
            width: 100%;
        }

        .social-block {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 7px 0;
            vertical-align: middle;

            img {
                height: 28px;
                width: auto;
            }

            span {
                font-size: 15px;
                line-height: 20px;
                color: #555A63;
                padding: 0 6px;
                margin-top: 0 !important;
            }
        }


        #social_dropdown {
            /*width: 250px !important;*/
            position: absolute;
            top: -45px;

            li {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin: 6px 0;
                padding: 10px 12px;

                img {
                    height: 28px;
                    width: auto;
                }

                span {
                    font-size: 15px;
                    line-height: 20px;
                    color: #555A63;
                    padding: 0 6px;
                }
            }
        }
    }

    .buttons_wrapper_between {
        margin-bottom: 60px;
        margin-top: 30px;

        .btn {
            min-width: auto;
        }
    }

    #biography {
        border: 1px solid #DADEED;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 10px;
        margin-top: 20px;

        &:focus {
            box-shadow: none;
        }
    }

    #profession_dropdown {
        padding: 0 3px;
        position: absolute;
        top: 45px !important;

        .select_zero {
            background: #f5f7fd;
        }

        li {
            margin: 3px 0;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
                padding-right: 15px;
            }

            span {
                color: black;
            }

            &.checked {
                background: #F4E8F5;
            }
        }
    }
}

@media screen and (max-width: 564px) {

    .container {
        padding: 0px .75rem;
    }
}

</style>
